// /api/startupのType
export type StartUpApiResponse = {
    client_id: string;
};

// API ERROR
export const STARTUP_API_ERRORS = {
    REQUEST_ERROR_8001: 'REQUEST_ERROR(8001)',
    REQUEST_ERROR_8001_STATUS_CODE: 'REQUEST_ERROR(8001)_%1',
};
